if(!customElements.get('tab-panels')) {
    class TabPanels extends HTMLElement {
        constructor() {
            super();
            this.tabs = this.querySelectorAll('[role="tablist"] [aria-controls]');
            this.panels = this.querySelectorAll('[role="tabpanel"]');

            this.tabs.forEach(tab => {
                const id = tab.getAttribute('aria-controls');

                tab.addEventListener('click', () => {
                    this.open(id);
                });
            });
        }

        open(id) {  
            const tab = this.querySelector(`[aria-controls="${id}"]`);
            const panel = this.querySelector(`#${id}`);
            if(!panel) return;

            this.tabs.forEach(el => {
                if(el === tab) {
                    el.setAttribute('aria-selected', 'true')
                } else {
                    el.setAttribute('aria-selected', 'false')
                }
            });

            this.panels.forEach(el => {
                if(el === panel) {
                    el.classList.add('selected');
                } else {
                    el.classList.remove('selected');
                }
            });

            window.dispatchEvent(new Event('resize'));
        }
    } 

    customElements.define('tab-panels', TabPanels);
}
 